import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { cn, PaletteUtils, RoutePaths } from '@shared/utils';
import type { GetInquiryResponse } from '@shared/api';
import { TravelStatus } from '@widgets';
import { Text } from '@shared/widgets';
import ChevronIcon from '@assets/icons/chevron.svg';
import dayjs from 'dayjs';

interface TravelHeaderProps {
  className?: string;
  inquiry: GetInquiryResponse;
}

export const TravelHeader = (props: TravelHeaderProps) => {
  const { t } = useTranslation('travel');

  return (
    <section
      className={cn(
        'flex h-fit flex-col gap-6 bg-white p-6 dark:bg-soft-black',
        PaletteUtils.isVcfcPalette && 'rounded-xl dark:border dark:border-gray-black',
        props.className,
      )}
    >
      <Link className='hover:underline' to={RoutePaths.travelMyRequests.onNavigate()}>
        <Text className='flex items-center gap-2' color='gray'>
          <ChevronIcon />
          {t('travelHeader.back')}
        </Text>
      </Link>
      <div className='flex flex-col gap-2'>
        <div className={cn('flex items-center justify-between gap-2', 'max-md:flex-wrap')}>
          <Text className='break-words' tag='h2' weight='semibold' size='3xl'>
            {props.inquiry.name}
          </Text>
          <TravelStatus className='shrink-0' status={props.inquiry.status} />
        </div>
        <Text tag='p' color='gray'>
          Submitted {dayjs(props.inquiry.createdOn).format('DD MMM YYYY')}
        </Text>
      </div>
    </section>
  );
};
